export default {
  computed: {
    canApproveOvertime() {
      return this.overtimeIsRequested && this.hasOvertimeApproveLink
    },

    hasOvertimeApproveLink() {
      const overtimeApproveLink = this.overtime._links.find(
        link => link.rel === 'approve'
      )
      return !!overtimeApproveLink
    },

    canEditOvertime() {
      return this.hasOvertimeUpdateLink
    },

    hasOvertimeUpdateLink() {
      const overtimeUpdateLink = this.overtime._links.find(
        link => link.rel === 'update'
      )

      return !!overtimeUpdateLink
    },

    canCancelOvertime() {
      return (
        !['CANCELLED', 'REJECTED'].includes(this.overtime.status) &&
        (this.overtime.cancelAllowed || !!this.overtime.cancelBlockedMessage)
      )
    },

    cancelOvertimeAllowed() {
      return this.overtime.cancelAllowed
    },

    cancelOvertimeBlockedMessage() {
      return this.overtime.cancelBlockedMessage || ''
    },

    cancellableUntilText() {
      if (!this.overtime.cancelAllowed || !this.overtime.cancellableUntil) {
        return ''
      }

      return `Cancellable until ${this.overtime.cancellableUntil}`
    },

    overtimePolicyNotEnforced() {
      return this.overtime.policyNotEnforced
    },

    overtimePolicyNotEnforcedMessage() {
      return this.overtime.policyNotEnforced
        ? this.overtime.policyNotEnforced.message
        : ''
    },

    overtimeIsRequested() {
      return this.overtime.status === 'REQUESTED'
    },
  },
}
